import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceEscalationsRoute: InvariantJiraRoute = {
	name: 'servicedesk-customer-service-escalations',
	path: '/jira/servicedesk/projects/:projectKey/escalations',
	exact: true,
};
